
import {} from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
@Component({
  components: {}
})
export default class PiSimOutRecord extends Vue {
  private time: object[] = [];
  private formInline: objAny = {
    startTime: "",
    endTime: "",
    name: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: ""
  };
  private loading = false;
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: "设备编号",
      key: "faultName",
      minWidth: 120
    },
    {
      title: "SIM卡ID",
      key: "faultCode",
      minWidth: 120
    },
    {
      title: "项目名称",
      key: "faultCode",
      minWidth: 120
    },
    {
      title: "创建时间",
      key: "faultCode",
      minWidth: 120
    }
  ];

  public timeChange(data: objAny): void {
    this.formInline.startTime = data.startTime;
    this.formInline.endTime = data.endTime;
    // this.getTableList();
  }
  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    // const ret = await getCosumerLogList(this.formInline);

    // if (ret.status === this.$config.apiStatus) {
    //   this.total = ret.total;
    //   this.tableList = ret.data;
    // }
    this.loading = false;
  }
  mounted() {
    const d: any = new Date();
    const end: number = Date.parse(d) / 1000;
    const start: number = end - 60 * 60 * 25 * 90;
    this.formInline.startTime = this.$common.userDate(start * 1000);
    this.formInline.endTime = this.$common.userDate(end * 1000);
    this.time = [this.formInline.startTime, this.formInline.endTime];
    this.getTableList();
  }
}
